import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { imgsT5 } from "../../../assets/imgs/Tema5";
import { QuestionCardV3 } from "../../../components/common/QuestionCardV3";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	questions: 3,
	win: 4,
	fail: 5,
}
const gameQuestion = [
	{
		id: 1,
		question: "Un Cliente desea ingresar dinero a su tarjeta, ¿Cuál es el primer paso a realizar?",
		img: imgsT5.question1,
		options: [
			{
				id: 1,
				text: "Dar clic en la opción Depósito",
			},
			{
				id: 2,
				text: "Dar clic en la opción Financieros",
				isCorrect: true
			},
			{
				id: 3,
				text: "Dar clic en la opción Depósito de tarjeta",
			},
		]
	},
	{
		id: 2,
		question: "¿Qué es necesario ingresar para continuar con tu proceso de corresponsalía?",
		img: imgsT5.question2,
		options: [
			{
				id: 1,
				text: "Usuario y contraseña",
				isCorrect: true,
			},
			{
				id: 2,
				text: "Usuario",
			},
			{
				id: 3,
				text: "Usuario y contraseña del Líder de Tienda",
			},
		]
	},
	{
		id: 3,
		question: "Después de ingresar la tarjeta del Cliente, ¿Qué es necesario realizar?",
		img: imgsT5.question3,
		options: [
			{
				id: 1,
				text: "Dar clic en siguiente",
			},
			{
				id: 2,
				text: "Dar clic en siguiente y solicitar el monto",
			},
			{
				id: 3,
				text: "Verificar el número de la tarjeta del Cliente y dar clic en siguiente",
				isCorrect: true,
			},
		]
	},
	{
		id: 4,
		question: "Después de ingresar el monto a depositar, ¿Qué debemos hacer?",
		img: imgsT5.question4,
		options: [
			{
				id: 1,
				text: "Dar clic al letrero de confirmar",
			},
			{
				id: 2,
				text: "Reafirmar con el Cliente el monto y dar clic en confirmar",
				isCorrect: true,
			},
			{
				id: 3,
				text: "Dar clic en confirmar y reafirmar con el Cliente el monto",
			},
		]
	},
	{
		id: 5,
		question: "¿Cuáles son los últimos pasos a realizar dentro de las corresponsalías?",
		img: imgsT5.question3,
		options: [
			{
				id: 1,
				text: "Subtotalizar e imprimir el comprobante",
				isCorrect: true,
			},
			{
				id: 2,
				text: "Subtotalizar y agradecer al Cliente",
			},
			{
				id: 3,
				text: "Imprimir el comprobante y entregarlo al Cliente",
			},
		]
	},
]
let pointsAcumulated = 0

export const Tema5SubtopicOneActivityTwo = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema5.activities.subtema1], 2);
	useEffect(() => {
		if (loaded) {
			console.log("tema 5 subtema1 activity 2");
			ObserverEmitter.emit(EVENTS.tema5.subtopicOne.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act2_a01)
	})

	const [selectQuestionGame, setSelectQuestionGame] = useState({
		question: "",
		img: "",
		options: [
			{
				id: 1,
				text: ""
			},
			{
				id: 2,
				text: ""
			},
			{
				id: 3,
				text: ""
			},
		]
	})
	const [numberQuestion, setNumberQuestion] = useState(0)
	const [saveResponse, setSaveResponse] = useState(0)

	const actionGameQuestion = (statusCorrect = 0) => {
		const updatedResponse = statusCorrect === 1 ? saveResponse + 1 : saveResponse;
		setSaveResponse(updatedResponse);

		// console.log(updatedResponse);
		pointsAcumulated = updatedResponse * 10

		if (numberQuestion >= gameQuestion.length - 1) {
			if (updatedResponse >= 2) {
				ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
				setUiToShow(steps.win);
			} else {
				ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
				setUiToShow(steps.fail);
			}
			return;
		}
		setNumberQuestion(numberQuestion + 1);
	};

	const setDataQuestion = () => {
		const selectData = gameQuestion[numberQuestion]
		setSelectQuestionGame(selectData)
	}

	useEffect(() => {
		setDataQuestion()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [numberQuestion])

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, 3].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema5.subtopicOne.initScene, 2);
						setNumberQuestion(0)
						setSaveResponse(0)
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Ejercicio: Preguntas." />
					<DialogBarNew
						dialog={
							'¡Bien! Pongamos a prueba nuestro tema de Corresponsalías. Selecciona la respuesta correcta.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.viewActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Corresponsalías"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.questions);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto)
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.questions && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<BarStatusActivies activities={tasksList} />
					<QuestionCardV3 data={selectQuestionGame} actionGameQuestion={actionGameQuestion} />
				</>
			)}
			{uiToShow === steps.win && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={pointsAcumulated}
						dialogModal="Has completado con éxito la sección sobre el Servicio de Corresponsalías."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: pointsAcumulated,
									subtema: tasksId.tema5.activities.subtema1,
								})
							);
							navigation("/home5/tema5/subtema1/results");
						}}
					/>
				</>
			)}
			{uiToShow === steps.fail && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="Respuesta incorrecta."
						numberPoints={pointsAcumulated}
						dialogModal="¡No pierdas el ánimo! Verifica nuevamente los pasos a seguir para las corresponsalías."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: pointsAcumulated,
									subtema: tasksId.tema5.activities.subtema1,
								})
							);
							navigation("/home5/tema5/subtema1/results");
						}}
					/>
				</>
			)}

		</>

	)
}